import React ,{useEffect} from "react";
import { Helmet } from "react-helmet";
import TermsAndconditions from "../../Rules/Termsconditions";
import { PageVisit } from "../../../Utility/API";
import { useSelector } from "react-redux";


const Termsconditions = () => {

  const state = useSelector((state) => state);

  useEffect(()=>{
     PageVisit(state?.auth?.user?.idUser || "","terms-conditions");
   },[]);

  return (
    <>
      <Helmet>
        <title>Terms and Conditions | BettDraft Fantasy Sports</title>
        <meta name="description" content="Read BettDraft's full terms and conditions for daily fantasy sports." />
      </Helmet>
      <TermsAndconditions />
    </>
  );
};

export default Termsconditions;
